import { Shelf, Image } from '@tracklib/kit'
import styles from './quotes2021.css'

type Quote = { name: string; image: number; text: string; description: string }

const Quote = ({ name, image, text, description }: Quote) => (
  <div>
    <div className={styles.image}>
      <Image image={image} alt={name} absolute />
    </div>
    <p className={styles.text}>{text}</p>
    <p className={styles.name}>{name}</p>
    <p className={styles.description}>{description}</p>
  </div>
)

type Quotes2021 = {
  value: {
    quotes: Array<Quote>
  }
}

const Quotes2021 = ({ value: { quotes } }: Quotes2021): JSX.Element => (
  <Shelf arrows extraPad className={styles.wrapper} swipeClassName={styles.shelfSwipe}>
    {quotes?.map(quote => (
      <Shelf.Item key={quote.name} className={styles.quote}>
        <Quote {...quote} />
      </Shelf.Item>
    ))}
  </Shelf>
)

export default Quotes2021
